import * as React from 'react';
import { SVGProps } from 'react';

const IconRulerFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 4H9v4H7V4H5v3H3V4H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2v3h-2V4Z" />
  </svg>
);
export default IconRulerFilledSizeS;
